import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import {
  configurationStepsState,
  indexColumnMatchesState,
  selectedEntityState,
  selectedTableState,
} from '../../state/ConfigurationState';

export function useResetConfigState() {
  const setActiveStep = useSetAtom(configurationStepsState);
  const setSelectedTableId = useSetAtom(selectedTableState);
  const setSelectedEntity = useSetAtom(selectedEntityState);
  const setIndexCols = useSetAtom(indexColumnMatchesState);

  return useCallback(() => {
    setActiveStep(0);
    setSelectedTableId(null);
    setSelectedEntity(null);
    setIndexCols(new Map());
  }, [setActiveStep, setIndexCols, setSelectedEntity, setSelectedTableId]);
}
